/* eslint-disable */
import { FieldType, FieldDataDefinition } from '../index';

declare var Object: any;
export interface FieldDefinitionInterface {
  id?: string;
  fieldName: string;
  title: string;
  config?: any;
  fieldTypeId?: string;
  parentFieldTypeId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  dataDefinitionId?: string;
  fieldType?: FieldType;
  dataDefinition?: FieldDataDefinition;
}

export class FieldDefinition implements FieldDefinitionInterface {
  'id'?: string;
  'fieldName': string;
  'title': string;
  'dataPreview': string;
  'fieldTypeId': string;
  'parentFieldTypeId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  'dataDefinitionId': string;
  fieldType: FieldType;
  dataDefinition: FieldDataDefinition;
  constructor(data?: FieldDefinitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FieldDefinition`.
   */
  public static getModelName() {
    return 'FieldDefinition';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of FieldDefinition for dynamic purposes.
   **/
  public static factory(data: FieldDefinitionInterface): FieldDefinition {
    return new FieldDefinition(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'FieldDefinition',
      plural: 'FieldDefinitions',
      path: 'field-definitions',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        fieldName: {
          name: 'fieldName',
          type: 'string',
        },
        title: {
          name: 'title',
          type: 'string',
        },
        config: {
          name: 'config',
          type: 'any',
        },
        fieldTypeId: {
          name: 'fieldTypeId',
          type: 'string',
        },
        parentFieldTypeId: {
          name: 'parentFieldTypeId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
        dataDefinitionId: {
          name: 'dataDefinitionId',
          type: 'string',
        },
      },
      relations: {
        fieldType: {
          name: 'fieldType',
          type: 'FieldType',
          model: 'FieldType',
          relationType: 'belongsTo',
          keyFrom: 'fieldTypeId',
          keyTo: 'id',
        },
        dataDefinition: {
          name: 'dataDefinition',
          type: 'FieldDataDefinition',
          model: 'FieldDataDefinition',
          relationType: 'belongsTo',
          keyFrom: 'dataDefinitionId',
          keyTo: 'id',
        },
      },
    };
  }
}
